import React from 'react';
import styled from 'styled-components';
import DogParkBookings from './DogParkBookings';

const PageWrapper = styled.div`
  padding-top: 20px;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding-top: 15px;
  }
`;

const DogParkBookingsPage = () => {
  return (
    <PageWrapper>
      <DogParkBookings />
    </PageWrapper>
  );
};

export default DogParkBookingsPage;
